import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { FloppyDisk } from "@phosphor-icons/react";

export default function AdminSettings() {
  const [about, setAbout] = useState("");
  const [social, setSocial] = useState({ instagram: "", tiktok: "", youtube: "", linkedin: "", whatsapp: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/about").then((r) => setAbout(r.data.narrative)).catch(() => {});
    api.get("/social").then((r) => setSocial({
      instagram: r.data.instagram || "",
      tiktok: r.data.tiktok || "",
      youtube: r.data.youtube || "",
      linkedin: r.data.linkedin || "",
      whatsapp: r.data.whatsapp || "",
    })).catch(() => {});
  }, []);

  const saveAbout = async () => {
    setSaving(true);
    try {
      await api.put("/admin/about", { narrative: about });
      toast.success("About updated");
    } catch { toast.error("Failed to save"); }
    finally { setSaving(false); }
  };

  const saveSocial = async () => {
    setSaving(true);
    try {
      await api.put("/admin/social", social);
      toast.success("Social links updated");
    } catch { toast.error("Failed to save"); }
    finally { setSaving(false); }
  };

  return (
    <div data-testid="admin-settings" className="space-y-8">
      <div>
        <h1 className="font-display text-3xl md:text-4xl font-black tracking-tighter">Settings</h1>
        <p className="text-slate-600 mt-1">Edit the public face of Hangang Global.</p>
      </div>

      <section className="brutal-card rounded-3xl p-6 md:p-8" data-testid="settings-about">
        <h2 className="font-display text-xl font-black mb-4">About narrative</h2>
        <textarea
          value={about}
          onChange={(e) => setAbout(e.target.value)}
          rows={8}
          data-testid="settings-about-textarea"
          className="w-full bg-white border-2 border-slate-200 rounded-2xl px-4 py-3 focus:border-[#FF6B9E] focus:outline-none font-medium resize-none"
        />
        <div className="mt-4 flex justify-end">
          <button onClick={saveAbout} disabled={saving} data-testid="settings-about-save" className="btn-pill-primary disabled:opacity-60">
            <FloppyDisk size={16} weight="bold" /> Save about
          </button>
        </div>
      </section>

      <section className="brutal-card rounded-3xl p-6 md:p-8" data-testid="settings-social">
        <h2 className="font-display text-xl font-black mb-4">Social links</h2>
        <div className="grid md:grid-cols-2 gap-4">
          {["instagram", "tiktok", "youtube", "linkedin", "whatsapp"].map((k) => (
            <div key={k}>
              <label className="label-uppercase block mb-2">{k}</label>
              <input
                type="url"
                value={social[k]}
                onChange={(e) => setSocial({ ...social, [k]: e.target.value })}
                data-testid={`settings-social-${k}`}
                placeholder={`https://${k}.com/your-handle`}
                className="w-full bg-white border-2 border-slate-200 rounded-2xl px-4 py-3 focus:border-[#FF6B9E] focus:outline-none font-medium"
              />
            </div>
          ))}
        </div>
        <div className="mt-4 flex justify-end">
          <button onClick={saveSocial} disabled={saving} data-testid="settings-social-save" className="btn-pill-primary disabled:opacity-60">
            <FloppyDisk size={16} weight="bold" /> Save links
          </button>
        </div>
      </section>
    </div>
  );
}
